import "banco/classes/SmartlookSupport";
import "banco/classes/LanguageObserver";
import "../lib/navbar";
import { setupDynamicBanner } from "banco-website/dynamic_banner";

setupDynamicBanner();
